import { useEffect, useState } from "react";
import GameBody from "../components/GameBody";
import WorldCupBar from "../components/WorldCupBar";

import Card from "../components/Card";

import Result from "../components/Result";
import Progress from "../components/Progress";
import { useNavigate } from "react-router-dom";
const gameData = [
  { id: 0, name: "해린(뉴진스)", image: "/worldcup/imgs/woman/해린.webp" },
  { id: 1, name: "민지(뉴진스)", image: "/worldcup/imgs/woman/민지.webp" },
  { id: 2, name: "카리나(에스파)", image: "/worldcup/imgs/woman/카리나.webp" },
  { id: 3, name: "윈터(에스파)", image: "/worldcup/imgs/woman/윈터.webp" },
  { id: 4, name: "고윤정", image: "/worldcup/imgs/woman/고윤정.webp" },
  {
    id: 5,
    name: "카즈하(르세라핌)",
    image: "/worldcup/imgs/woman/카즈하.webp",
  },
  {
    id: 6,
    name: "김채원(르세라핌)",
    image: "/worldcup/imgs/woman/김채원.webp",
  },
  { id: 7, name: "권은비", image: "/worldcup/imgs/woman/권은비.webp" },
  { id: 8, name: "이영지", image: "/worldcup/imgs/woman/이영지.webp" },
  { id: 9, name: "아이유", image: "/worldcup/imgs/woman/아이유.webp" },
  { id: 10, name: "화사", image: "/worldcup/imgs/woman/화사.webp" },
  { id: 11, name: "사나(트와이스)", image: "/worldcup/imgs/woman/사나.webp" },
  { id: 12, name: "쯔위(트와이스)", image: "/worldcup/imgs/woman/쯔위.webp" },
  {
    id: 13,
    name: "아린(오마이걸)",
    image: "/worldcup/imgs/woman/아린.webp",
  },
  {
    id: 14,
    name: "승희(오마이걸)",
    image: "/worldcup/imgs/woman/승희.webp",
  },
  { id: 15, name: "진종서", image: "/worldcup/imgs/woman/진종서.webp" },
  { id: 16, name: "임지연", image: "/worldcup/imgs/woman/임지연.webp" },
  { id: 17, name: "조이현", image: "/worldcup/imgs/woman/조이현.webp" },
  { id: 18, name: "장도연", image: "/worldcup/imgs/woman/장도연.webp" },
  { id: 19, name: "윤아", image: "/worldcup/imgs/woman/윤아.webp" },
  { id: 20, name: "김세정", image: "/worldcup/imgs/woman/김세정.webp" },
  { id: 21, name: "정호연", image: "/worldcup/imgs/woman/정호연.webp" },
  { id: 22, name: "신세경)", image: "/worldcup/imgs/woman/신세경.webp" },
  { id: 23, name: "태연", image: "/worldcup/imgs/woman/태연.webp" },
  { id: 24, name: "권나라", image: "/worldcup/imgs/woman/권나라.webp" },
  { id: 25, name: "공승연", image: "/worldcup/imgs/woman/공승연.webp" },
  { id: 26, name: "박보영", image: "/worldcup/imgs/woman/박보영.webp" },
  { id: 27, name: "설인아", image: "/worldcup/imgs/woman/설인아.webp" },
  { id: 28, name: "노윤서", image: "/worldcup/imgs/woman/노윤서.webp" },
  { id: 29, name: "박은빈", image: "/worldcup/imgs/woman/박은빈.webp" },
  { id: 30, name: "한소희", image: "/worldcup/imgs/woman/한소희.webp" },
  { id: 31, name: "장원영", image: "/worldcup/imgs/woman/장원영.webp" },
];

export default function Man() {
  const TOTAL_ROUND = 31;
  const navigator = useNavigate();
  const [result, setResult] = useState(false);
  const [completedRound, setCompletedRound] = useState(0);
  const [progressRound, setProgressRound] = useState(null);
  const [selectedCards, setSelectedCards] = useState([]);
  const [remainingCards, setRemainingCards] = useState(gameData);

  const [game16, setGame16] = useState([]);
  const [game8, setGame8] = useState([]);
  const [game4, setGame4] = useState([]);
  const [game2, setGame2] = useState([]);

  const [last, setLast] = useState(null);

  const initializeGame = () => {
    const shuffled = remainingCards.sort(() => 0.5 - Math.random());

    const selected = shuffled.slice(0, 2);
    setSelectedCards(selected);
  };
  const startGame = (list, result) => {
    const remaining = remainingCards.slice(2);

    if (game16.length < 16) {
      setGame16((prev) => [...prev, list]);
    } else if (game8.length < 8 && game16.length >= 16) {
      setGame8((prev) => [...prev, list]);
    } else if (game8.length >= 8 && game4.length < 4) {
      setGame4((prev) => [...prev, list]);
    } else if (game4.length >= 4 && game2.length < 2) {
      setGame2((prev) => [...prev, list]);
    } else {
      setLast(list);
    }

    setRemainingCards(remaining);
    setCompletedRound((prev) => prev + 1);
    if (result) {
      setResult(true);
    }
  };

  useEffect(() => {
    initializeGame();
    gameData.forEach(({ image }) => {
      const img = new Image();
      img.src = image;
    });
  }, []);
  useEffect(() => {
    if (game16.length === 16 && game8.length === 0) {
      setRemainingCards(game16);
    } else if (game8.length === 8 && game4.length === 0) {
      setRemainingCards(game8);
    } else if (game4.length === 4 && game2.length === 0) {
      setRemainingCards(game4);
    } else if (game2.length === 2 && last === null) {
      setRemainingCards(game2);
    }
    setSelectedCards(remainingCards.slice(0, 2));
    const progressRound = (completedRound / TOTAL_ROUND) * 100;
    setProgressRound(progressRound.toFixed(0));
    if (result) {
      const url = new URLSearchParams();
      url.append("image", last.image);
      url.append("name", last.name);
      const query = url.toString();
      navigator(`/result?${query}`);
    }
  }, [remainingCards]);

  const round = () => {
    if (game16.length < 16) return "32강";
    if (game8.length < 8) return "16강";
    if (game4.length < 4) return "8강";
    if (game2.length < 2) return "4강";
    return "결승";
  };

  return (
    <>
      <WorldCupBar round={round()} currendRound={completedRound + 1} />
      <GameBody
        gameData={selectedCards}
        startGame={startGame}
        result={completedRound === 30 && true}
      />
      <Progress progressRound={progressRound} />
    </>
  );
}
